import {getApprovalProcessById} from "../../../../api/approval/ApprovalProcessService";
import {selectApprovalGroupsByProcessId} from "../../../../api/approval/ApprovalGroupService";
import {needAuth} from "../../../../api/instance/Instance";

async function fetchApproversByGroupId(approvalGroupId) {
    if (approvalGroupId == null) {
        return [];
    }

    try {
        const response = await needAuth.get(`/approvers/${approvalGroupId}`);
        return response?.status === 200 && Array.isArray(response.data) ? response.data : [];
    } catch {
        return [];
    }
}

function groupHasEmbeddedApprovers(group) {
    return (
        (Array.isArray(group?.approvers) && group.approvers.length > 0)
        || (Array.isArray(group?.contentApprovers) && group.contentApprovers.length > 0)
    );
}

async function enrichGroupsWithApprovers(groups) {
    const sorted = [...(groups ?? [])].sort((a, b) => (a.orders ?? 0) - (b.orders ?? 0));

    return Promise.all(
        sorted.map(async (group) => {
            if (groupHasEmbeddedApprovers(group)) {
                return {
                    ...group,
                    approvers: group.approvers ?? group.contentApprovers ?? [],
                };
            }

            const approvers = await fetchApproversByGroupId(group.id);
            return {...group, approvers};
        }),
    );
}

/**
 * 결재 프로세스 상세 조회
 * - v2: process.approvers
 * - 레거시: approvalGroups + 그룹별 /approvers 조회 (그룹당 다수 결재자 지원)
 */
export async function fetchApprovalProcessDetail(processId) {
    if (processId == null) {
        return null;
    }

    const processResponse = await getApprovalProcessById(processId);
    if (processResponse?.status !== 200) {
        return null;
    }

    const process = {...processResponse.data};

    if (Array.isArray(process.approvers) && process.approvers.length > 0) {
        return process;
    }

    let groups = process.approvalGroups;
    if (!Array.isArray(groups) || groups.length === 0) {
        const groupsResponse = await selectApprovalGroupsByProcessId(processId);
        groups = groupsResponse?.status === 200 && Array.isArray(groupsResponse.data)
            ? groupsResponse.data
            : [];
    }

    process.approvalGroups = await enrichGroupsWithApprovers(groups);
    return process;
}
